<template>
  <v-card>
    <v-row wrap>
      <v-col cols="12" lg="6">
        <!-- Profile user infos -->
        <Profile settings></Profile>
        <!-- Firm list -->
        <StaffList></StaffList>
      </v-col>
      <!-- Firm list -->
      <v-col cols="12" lg="6">
        <FirmList></FirmList>
        <v-layout justify-center>
          <v-btn
            rounded
            small
            text
            color="primary"
            to="/dashboard"
          >{{ $t('welcome.btn-2') }}</v-btn>
        </v-layout>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Profile from '@/components/profile/Profile'
import FirmList from '@/components/firm/FirmList'
import StaffList from '@/components/profile/staff/StaffList'

export default {
  components: {
    Profile: Profile,
    FirmList: FirmList,
    StaffList: StaffList
  },
  data () {
    return {
      logo: process.env.BASE_URL
    }
  }
}
</script>
